import { PrismicNextImage } from "@prismicio/next";
import { PrismicRichText } from "@prismicio/react";
import React from "react";
import s from "./feature-details.module.scss";
import { IoCheckmarkCircleOutline } from "react-icons/io5";

const FeatureDetails = ({ data }) => {
  return (
    <div
      className={`${s.container} ${data.is_image_left === true ? s.imageLeft : s.imageRight}`}
    >
      <div className={s.contentWrapper}>
        <div className={s.title}>
          <PrismicRichText field={data.feature_details_title} />
        </div>
        <div className={s.description}>
          <PrismicRichText field={data.feature_details_description_1} />
        </div>
        <div className={s.list}>
          {data.feature_details_list &&
            data.feature_details_list.map((item, index) => (
              <div key={index} className={s.listItem}>
                <IoCheckmarkCircleOutline size={24} /> {item.label}
              </div>
            ))}
        </div>
        <div className={s.description}>
          <PrismicRichText field={data.feature_details_description_2} />
        </div>
      </div>

      <div className={s.image}>
        <PrismicNextImage field={data.feature_details_image} fallbackAlt="" />
      </div>
    </div>
  );
};

export default FeatureDetails;
